import * as localforage from "localforage";
import type {EBirdChecklistByFamily, EBirdObservationsByLocation, EBirdObservationsBySpecies} from "ebird-mydata-reader";
import {LIFE_JOURNEY_CACHE_KEY} from "../views/discover/constants";
import type {LocationEcoregionData} from "./types";

export const DERIVED_BIRD_DATA_CACHE_KEY = 'derivedBirdDataCache';
export const DERIVED_BIRD_DATA_CACHE_VERSION = 2;
export const LOCATION_ECO_DATA_CACHE_KEY = 'locationEcoDataCache';
export const LOCATION_ECO_DATA_CACHE_VERSION = 1;

export type CachedDerivedBirdData = {
    version: number,
    observationsBySpecies: EBirdObservationsBySpecies[],
    observationsByLocation: EBirdObservationsByLocation[],
    checklist: EBirdChecklistByFamily[]
}

export type CachedLocationEcoData = {
    version: number,
    ecoDataByLocationId: Record<string, LocationEcoregionData>
}

export const clearDerivedBirdDataCaches = async () => {
    await Promise.all([
        localforage.removeItem(DERIVED_BIRD_DATA_CACHE_KEY),
        localforage.removeItem(LOCATION_ECO_DATA_CACHE_KEY),
        localforage.removeItem(LIFE_JOURNEY_CACHE_KEY)
    ]);
}
